import { academyDateKey } from '../utils/date.js';

const nullable = (value) => value === '' || value === undefined ? null : value;
const phone = (value) => nullable(String(value || '').replace(/\D/g, ''));
const stages = { '초등': 'elementary', '중등': 'middle', '고등': 'high', '재수': 'other' };
const statuses = { '재원': 'enrolled', '휴원': 'paused', '퇴원': 'withdrawn', '졸업': 'graduated' };
export function registrationPayload(id, form, manager) {
  const selected = form.registrationEnrollments || [];
  if (!id || !Array.isArray(selected) || selected.length > 20 || (!manager && selected.length))
    throw new Error('수업 배정 권한과 선택한 수업을 확인해 주세요.');
  const seen = new Set();
  for (const item of selected) {
    if (!item.courseGroupId || seen.has(item.courseGroupId) || !['pending','confirmed'].includes(item.setupStatus) ||
      (item.setupStatus === 'confirmed' && (!item.startDate || item.firstMonthAdjustment === '' || item.firstMonthAdjustment == null)) ||
      (item.setupStatus === 'pending' && (item.startDate || item.firstMonthAdjustment != null || item.endDate)) ||
      (item.endDate && item.endDate < item.startDate) || (item.endDate && !item.endReason) ||
      item.appliedTuition === '' || item.appliedTuition == null ||
      !Number.isFinite(Number(item.appliedTuition)) || Number(item.appliedTuition) < 0 ||
      (item.firstMonthAdjustment != null && item.firstMonthAdjustment !== '' &&
        (!Number.isFinite(Number(item.firstMonthAdjustment)) || Number(item.firstMonthAdjustment) < 0)))
      throw new Error('선택한 수업의 기간과 금액을 확인해 주세요.');
    seen.add(item.courseGroupId);
  }
  return {
    registration_id: id,
    student_input: {
      name: form.name.trim(), gender: nullable({ '남': 'male', '여': 'female' }[form.gender]),
      school_stage: stages[form.schoolLevel], school_name: nullable(form.school?.trim()),
      grade: Number(form.grade) || null, school_class: nullable(form.className), phone: phone(form.phone),
      registered_on: form.joinedAt || academyDateKey(), memo: nullable(form.memo), status: statuses[form.status],
      ...(manager ? { default_payment_method: nullable(form.billingMethod) } : {}),
    },
    guardian_input: form.parentPhone ? {
      name: form.parentName?.trim() || '보호자', relationship: form.guardianRelationship || '보호자',
      phone: phone(form.parentPhone), sms_consent: form.smsConsent ?? false,
    } : null,
    enrollment_inputs: selected.map(item => ({
      course_group_id: item.courseGroupId, setup_status: item.setupStatus, starts_on: item.startDate || null, ends_on: nullable(item.endDate),
      end_reason: item.endDate ? item.endReason : null, applied_tuition: Number(item.appliedTuition),
      first_month_adjustment: item.firstMonthAdjustment === '' || item.firstMonthAdjustment == null
        ? null : Number(item.firstMonthAdjustment), memo: nullable(item.memo),
    })),
  };
}
